import * as React from 'react';
import {connect} from 'react-redux';

import {Assignables} from 'nutshell-core/assignables';
import {EmailSequenceTemplateGroups} from 'nutshell-core/email-sequence-template-groups';
import {safelyGetFilterByKey} from 'nutshell-core/filter';
import type {FilterObject, Assignable, EmailSequenceTemplateGroup} from 'nutshell-core/types';

import {convertToModels} from 'shells/filter-capsule/convert-to-models';
import {FilterCapsule} from 'shells/filter-capsule/filter-capsule';

import type {NutshellState} from '../../../store';

import {EMAIL_REPORT_SCHEMA} from '../report-constants';

type OwnProps = {
    filters: Array<FilterObject>;
    onFilterSubmit: (filterObj: FilterObject) => void;
    onFilterRemove: (filterKey: string) => void;
};

type StateProps = {
    assignables: Assignable[];
    emailSequenceTemplateGroups: EmailSequenceTemplateGroup[];
};

type Props = OwnProps & StateProps;

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        assignables: Assignables.getAll(state),
        emailSequenceTemplateGroups: EmailSequenceTemplateGroups.getAll(state),
    };
};

export class EmailReportFiltersComponent extends React.Component<Props> {
    render() {
        const emailSequenceTemplateGroupModels =
            convertToModels(this.props.emailSequenceTemplateGroups) || [];

        return (
            <>
                <FilterCapsule
                    size='big'
                    collection={convertToModels(this.props.assignables)}
                    filter={safelyGetFilterByKey(this.props.filters, 'recipient')}
                    filterName='recipient'
                    displayCountOnly={true}
                    // @ts-expect-error
                    schemaField={EMAIL_REPORT_SCHEMA.recipient}
                    onSubmit={this.props.onFilterSubmit}
                    onUpdate={this.props.onFilterSubmit}
                    onRemove={this.props.onFilterRemove}
                />
                <FilterCapsule
                    size='big'
                    collection={emailSequenceTemplateGroupModels}
                    filter={safelyGetFilterByKey(this.props.filters, 'emailSequenceTemplateGroups')}
                    filterName='emailSequenceTemplateGroups'
                    displayCountOnly={true}
                    // @ts-expect-error
                    schemaField={EMAIL_REPORT_SCHEMA.emailSequenceTemplateGroup}
                    onSubmit={this.props.onFilterSubmit}
                    onUpdate={this.props.onFilterSubmit}
                    onRemove={this.props.onFilterRemove}
                />
            </>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const EmailReportFilters = connector(EmailReportFiltersComponent);
